<template>
	<div>
		<template v-if="!disabled && !readonly">
			<van-field :required="formCreateInject.rule.validate.required" readonly :disabled="disabled"
				:label="formCreateInject.prop.title.title" :value="valuetext" placeholder="" @click="showPicker = true"
				input-align="right">
				<template #left-icon>
					<van-icon v-if="!disabled && !readonly" name="edit" color="#07c160" />
				</template>
			</van-field>
			<van-popup get-container="body" v-model="showPicker" round position="bottom">
				<van-picker value-key="label" show-toolbar :columns="selectoption" @cancel="showPicker = false"
					@confirm="onConfirm" :title="formCreateInject.prop.title.title" />
			</van-popup>
		</template>
		<template v-else>
			<van-field readonly :label="formCreateInject.prop.title.title" :value="valuetext"
				placeholder="" input-align="right" />
		</template>
	</div>
</template>
<style scoped>
	.readonly {
		pointer-events: none;
	}

	.readonly>* {
		pointer-events: none;
	}

	.form_loading {
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
</style>
<script>
	import staff from '@_system/components/formcomponents/common/select/staff/select.vue'

	export default {
		extends: staff,
		data() {
			return {
				showPicker: false,
				options: [],
				selectoption: [],
				columns: [],
			}
		},
		created() {

		},
		mounted() {
			let selectoption = []
			let options = this.options
			//console.log(this.options)
			options = options.filter((item)=>{
				return item.status == 3 && item.enable == 5
			})
			options.forEach((item) => {
				let index = selectoption.findIndex((i) => {
					return i.value == item.departmentid
				})
				if (index === -1) {
					selectoption.push({
						label: window.systemMethods.getdepartment(item.departmentid),
						value: item.departmentid,
						children: [item],
					})
				} else {
					selectoption[index].children.push(item)
				}
			})
			this.selectoption = selectoption
		},
		watch: {

		},
		computed: {

		},
		methods: {
			onConfirm(value, index) {
				if (value) {
					let postvalue = ''
					if (Array.isArray(value)) {
						let currentobj = this.selectoption
						let objarr = []
						index.forEach((item) => {
							objarr.push(currentobj[item])
							currentobj = currentobj[item].children
						})
						postvalue = objarr[objarr.length - 1].value
					} else {
						postvalue = value.value
					}
					this.change(postvalue)
				}
				this.showPicker = false
			},
		},
		components: {

		}
	}
</script>
